export default "/images/15cc1564c3e7e527034c79b3ace38486.avif";